<template lang="pug">
.page
  h3 {{ pageTitle }}
  .form(v-if="ready")
    .form-element
      RomatchCheckbox(label="Verbergen voor publiek" v-model="vacancy.hidden" :disabled="isSaving")
    .form-element
      RomatchInput(label="Titel *" v-model="vacancy.title" :disabled="isSaving" @blur="$v.vacancy.title.$touch()")
      .validation-error(v-show="$v.vacancy.title.$error") Dit veld is vereist
    .form-element
      RomatchInput(label="Locatie *" v-model="vacancy.location" :disabled="isSaving" @blur="$v.vacancy.location.$touch()")
      .validation-error(v-show="$v.vacancy.location.$error") Dit veld is vereist
    .form-element
      RomatchInput(label="Dienstverband *" v-model="vacancy.employment" :disabled="isSaving" @blur="$v.vacancy.employment.$touch()")
      .validation-error(v-show="$v.vacancy.employment.$error") Dit veld is vereist
    .form-element
      RomatchTextarea(label="Korte samenvatting" v-model="vacancy.summary" :disabled="isSaving")
    .form-element
      RomatchRichEditor(label="Beschrijving" v-model="vacancy.description" :disabled="isSaving")
    .form-buttons
      RomatchAdminButton#save(@click="cancel" :disabled="isSaving") Annuleren
      RomatchAdminButton#save(@click="save" :disabled="isSaving") Opslaan
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import RomatchRichEditor from '@/components/RomatchRichEditor.vue'

export default {
  name: 'VacancyForm',
  components: { RomatchRichEditor },
  data() {
    return {
      vacancy: {
        id: null,
        title: null,
        location: null,
        employment: null,
        summary: null,
        description: null,
        hidden: false,
      },
      isSaving: false,
      ready: false,
    }
  },
  validations: {
    vacancy: {
      title: { required },
      location: { required },
      employment: { required },
    },
  },
  computed: {
    ...mapGetters('vacancies', ['findVacancy']),
    isEdit() {
      return !!this.vacancy.id
    },
    pageTitle() {
      return this.isEdit ? 'Vacature bewerken' : 'Nieuwe vacature toevoegen'
    },
  },
  methods: {
    ...mapActions('vacancies', [
      'maybeFetchVacancies',
      'updateVacancy',
      'createVacancy',
      'updateVacancy',
    ]),
    cancel() {
      this.$router.go(-1)
    },
    async save() {
      if (this.$v.$invalid) {
        alert('Vul de vereiste velden in') // todo: improve this
        return
      }
      this.isSaving = true
      try {
        await this.upsertVacancy()
        this.$router.push({ name: 'vacancies' })
        this.$notifySuccess('Vacature opgeslagen')
      } catch (e) {
        this.$notifySuccess('Er ging iets mis bij het opslaan van de vacature')
        console.error(e)
      }
      this.isSaving = false
    },
    async upsertVacancy() {
      const vacancy = { ...this.vacancy } // shallow copy
      delete vacancy.reactions
      if (vacancy.id) return await this.updateVacancy(vacancy)
      else return await this.createVacancy(vacancy)
    },
  },
  async created() {
    await this.maybeFetchVacancies()
    const id = this.$route.params.id
    if (id) {
      this.vacancy = this.findVacancy(id)
    }
    this.ready = true
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

h3
  margin 2rem 0
  font-weight bold

.page
  max-width romatch-max-width
  margin auto
  padding-top 3rem
</style>
